import { render, staticRenderFns } from "./AreaManage.vue?vue&type=template&id=58d25a1c&scoped=true"
import script from "./AreaManage.vue?vue&type=script&lang=js"
export * from "./AreaManage.vue?vue&type=script&lang=js"
import style0 from "./AreaManage.vue?vue&type=style&index=0&id=58d25a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d25a1c",
  null
  
)

export default component.exports